placeholder for host activation